// @ constants
const actionTypes = require('constants/actionTypes');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');

const openYoungChoreStatusUpdateRequest = () => ({
    type: actionTypes.OPENYOUNG_CARD_CHORE_STATUS_UPDATE_REQUEST
});

const openYoungChoreResetStatusUpdateInfo = () => ({
    type: actionTypes.OPENYOUNG_CARD_CHORE_RESET_STATUS_UPDATE_INFO
});

const openYoungChoreStatusUpdateSuccess = (cardDetails) => ({
    type: actionTypes.OPENYOUNG_CARD_CHORE_STATUS_UPDATE_SUCCESS,
    payload: {
        cardDetails
    }
});

const openYoungChoreStatusUpdateFailure = (error) => ({
    type: actionTypes.OPENYOUNG_CARD_CHORE_STATUS_UPDATE_ERROR,
    payload: {
        error
    }
});

const updateChoreStatus = (choreStatusDetails) => (dispatch) => {
    const requestData = {
        query: {
            choreStatusId: choreStatusDetails.choreStatusId,
            confirmationComment: choreStatusDetails.confirmationComment,
            reward: choreStatusDetails.reward
        }
    }

    dispatch(openYoungChoreStatusUpdateRequest());
    return APIPost({
        dispatch,
        url: apiURLBuilder.getURL('openYoungChoreStatusUpdate', { choreAssignmentId: choreStatusDetails.choreAssignmentId }),
        params: requestData
    })
    .then(response => dispatch(openYoungChoreStatusUpdateSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(openYoungChoreStatusUpdateFailure(response.error));
        } else {
            throw response;
        }
    })
}

module.exports = {
    openYoungChoreResetStatusUpdateInfo,
    openYoungChoreStatusUpdateFailure,
    openYoungChoreStatusUpdateRequest,
    updateChoreStatus
}
